<template>
<div id="user-login" v-if="show">
    <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <button @click.prevent="show = null" type="button" class="close float-right">
                                <span aria-hidden="true"><div class="icon icon-close"></div></span>
                            </button>
                            <h2 class="text-center">{{$t('auth.login.title')}}</h2>
                            <form class="form-horizontal" method="POST" action="/login">
                                <input-field :label="$t('auth.login.email')" v-model="credentials.email" type="email" name="email" :required="true" :errors="loginErrors"></input-field>
                                <input-field :label="$t('auth.login.password')" v-model="credentials.password" type="password" name="password" :required="true" :errors="loginErrors"></input-field>
                                <div class="row justify-content-center">
                                    <div class="col-9">
                                        <button type="submit" @click.prevent="attemptLogin" class="btn btn-outline-green w-100">
                                            {{$t('auth.login.btn')}}
                                        </button>
                                        <br><br>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 text-left">
                                        <a href="/register">{{$t('auth.login.register')}}</a>
                                    </div>
                                    <div class="col-6 text-right">
                                        <a href="/password/reset">{{$t('auth.login.forgot')}}</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" @click.prevent="show = null"></div>
</div>
</template>

<script>

import InputField from '@Components/checkout/modules/InputField'
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('user')

export default {

    components: {
        InputField
    },

    data() {
        return {
            show: false,
            credentials: {
                email: null,
                password: null
            }
        }
    },

    created() {
        App.dispatcher.listen('user-login.open', show => this.show = true)
    },

    computed: mapState(['loading', 'loginErrors']),

    methods: {
        ...mapActions(['login']),

        async attemptLogin() {
            await this.login(this.credentials)
            window.location.reload()
        }
    }

}
</script>
